import {EScene} from '@/types/scene.types'
import {useTracking} from '@repo/shared/Tracking/Tracking.hooks'
import {getTrackingGameMode} from '@repo/shared/Tracking/Tracking.utils'
import {useAtomValue} from 'jotai'
import {useEffect} from 'react'
import {useTransitionState} from 'react-transition-state'
import {gameCodeState, gameModeState, sceneState} from '../Store/atoms'
import {Countdown} from './Countdown'

export const CountdownScreen = () => {
  const scene = useAtomValue(sceneState)
  const gameCode = useAtomValue(gameCodeState)
  const gameMode = useAtomValue(gameModeState)
  const {trackScreenEnter} = useTracking()

  const [state, toggle] = useTransitionState({
    timeout: {
      enter: 0,
      exit: 200, // <-- time allowed for the exit animation
    },
  })

  /**
   * If the scene is started countdown, toggle the transition
   */
  useEffect(() => {
    if (scene === EScene.STARTED_COUNTDOWN) {
      toggle(true)

      trackScreenEnter({
        screenIdentifier: 'start',
        abstractPath: '/start',
        meta: {
          gameCode: gameCode?.toString() ?? undefined,
          gameMode: getTrackingGameMode(gameMode),
        },
      })
    } else {
      toggle(false)
    }
  }, [scene])

  /**
   * If the status is exited, don't render anything
   */
  if (state.status === 'exited') {
    return null
  }

  return <Countdown transitionStatus={state.status} />
}
